<template lang="pug">
  v-container(fluid)#welcomeLottie
    #thelottie
</template>

<script>
import * as lottiefied from 'lottie-web';
import welcomeData from '../assets/lottieFiles/welcomeToCOR_UCC.json';
export default {
  mounted() {
    this.dapimate = lottiefied.loadAnimation({
      container: document.getElementById('thelottie'),
      loop: false,
      autoplay: true,
      renderer: 'svg',
      animationData: welcomeData
      // rendererSettings: this.options.rendererSettings
    });
  }
};
</script>
<style lang="stylus">
#welcomeLottie
  // width 100%

#thelottie
  // width 75%
  // height auto

@media screen and (max-width: 950px)
  #welcomeLottie
    margin-top 60px
</style>

<style lang="stylus" scoped></style>
